import React from 'react'
import {Presenter} from './Presenter'

export const Import = () => {
  return <Presenter />
}
